import React, { lazy, Suspense } from 'react';

const ParagraphWasteCostCalculator = lazy(() => import('./index.lazy'));

const ParagraphWasteCostCalculatorSuspense = (props) => (
  <Suspense>
    <ParagraphWasteCostCalculator {...props} />
  </Suspense>
);

export default ParagraphWasteCostCalculatorSuspense;
